import Model from "@tripian/model";
import moment from "moment";
import React from "react";
import TripianLogo from "../../../assets/img/Tripian_Logo.png";
// import visa from "../img/visa.png";

type Props = {
  theme?: "dark" | "light";
  t: (value: Model.TranslationKey) => string;
};

const Footer: React.FC<Props> = ({ theme = "light", t }) => {
  return (
    <footer className="w-full bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        {/* Logo and Navigation */}
        <div className="flex flex-col items-start md:items-center gap-8 mb-8 md:mb-12">
          {/* Logo */}
          <img
            src={
              theme === "dark"
                ? window.tconfig.IMAGE_PATHS.LOGO_PATH_DARK
                : window.tconfig.IMAGE_PATHS.LOGO_PATH_LIGHT || TripianLogo
            }
            alt="Provider Logo"
            className="h-8 w-auto"
          />

          {/* Navigation Links - Mobile: 2 columns, Desktop: horizontal */}
          <nav className="w-full grid grid-cols-2 gap-x-12 gap-y-3 md:flex md:flex-wrap md:justify-center md:items-center md:gap-8">
            <a
              href="/"
              className="text-gray-600 hover:text-gray-900 font-medium text-sm md:text-base transition-colors"
            >
                {t('overview.desktop')}
            </a>

              {/*<a*/}
              {/*    href="/features"*/}
              {/*    className="text-gray-600 hover:text-gray-900 font-medium text-sm md:text-base transition-colors"*/}
              {/*>*/}
              {/*    {t('trips.myTrips.itinerary.step.features')}*/}
              {/*</a>*/}

              {/*<a*/}
              {/*    href="/pricing"*/}
              {/*    className="text-gray-600 hover:text-gray-900 font-medium text-sm md:text-base transition-colors"*/}
              {/*>*/}
              {/*    {t('valai.footer.pricing')}*/}
              {/*</a>*/}
            {/*<a*/}
            {/*  href="/careers"*/}
            {/*  className="text-gray-600 hover:text-gray-900 font-medium text-sm md:text-base transition-colors"*/}
            {/*>*/}
            {/*    {t('valai.footer.careers')}*/}
            {/*</a>*/}
            {/*<a*/}
            {/*  href="/help"*/}
            {/*  className="text-gray-600 hover:text-gray-900 font-medium text-sm md:text-base transition-colors"*/}
            {/*>*/}
            {/*  Help*/}
            {/*</a>*/}
            <a
              href="https://tripian.com/privacy-policy"
              target="_blank"
              className="text-gray-600 hover:text-gray-900 font-medium text-sm md:text-base transition-colors"
              rel="noreferrer"
            >
              {t('valai.footer.privacy')}
            </a>
            <a
              href="https://tripian.com/terms-conditions"
              target="_blank"
              className="text-gray-600 hover:text-gray-900 font-medium text-sm md:text-base transition-colors"
              rel="noreferrer"
            >
              {t('valai.footer.terms')}
            </a>
          </nav>
        </div>

        {/* Bottom Section - Copyright and Links */}
        <div className="pt-8 border-t border-gray-200">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
            {/* Bottom Links - Mobile: first, Desktop: second */}
            <div className="flex items-center gap-4 md:gap-6 order-1 md:order-2">
              <a
                href="https://tripian.com/terms-conditions"
                target="_blank"
                className="text-gray-500 hover:text-gray-900 text-sm transition-colors"
                rel="noreferrer"
              >
                  {t('valai.footer.terms')}
              </a>
              <a
                href="https://tripian.com/privacy-policy"
                target="_blank"
                className="text-gray-500 hover:text-gray-900 text-sm transition-colors"
                rel="noreferrer"
              >
                  {t('valai.footer.privacy')}
              </a>
              {/*<a*/}
              {/*  href="/cookies"*/}
              {/*  className="text-gray-500 hover:text-gray-900 text-sm transition-colors"*/}
              {/*>*/}
              {/*    {t('valai.footer.cookies')}*/}
              {/*</a>*/}
            </div>

            {/* Copyright - Mobile: second, Desktop: first */}
            <div className="text-gray-500 text-sm order-2 md:order-1">
              © {moment().format("YYYY")} {window.tconfig.BRAND_NAME}. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
